import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import * as VueGoogleMaps from "vue2-google-maps";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import axios from "axios";
import "@/assets/css/style.css";
import "@/design/index.scss";
import jQuery from "jquery";
import Toasted from "vue-toasted";
import VueLazyLoad from "vue-lazyload";
import store from "@/state/store";
import App from "./App.vue";
import { initFirebaseBackend } from "./authUtils";
import i18n from "./i18n";
import tinymce from "vue-tinymce-editor";
import Multiselect from "vue-multiselect";
import config from "../src/config/config";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import pagination from "laravel-vue-pagination";

Vue.component("tinymce", tinymce);
Vue.component("multiselect", Multiselect);
Vue.component("v-select", vSelect);
Vue.component("pagination", pagination);

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
}
window.axios = axios;
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_KEY,
    libraries: "places",
  },
  installComponents: true,
});
Vue.component("vue-google-autocomplete", VueGoogleAutocomplete);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.component("apexchart", VueApexCharts);

Vue.use(Toasted, {
  duration: 4000,
  position: "top-right",
  action: {
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    },
  },
});

Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  error: config.no_image,
  attempt: 1,
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

window.Vue = Vue;
window.jQuery = jQuery;
window.axios.defaults.baseURL = process.env.VUE_APP_APIURL;
//window.axios.defaults.headers.common[{'Content-Type': 'multipart/form-data'}];
